import { useEffect } from "react";
import {
  Driver,
  Maybe,
  useGetDriverDefaultRoutingConfigurationsLazyQuery,
} from "@api/graphql/generated/generated-types";
import { useDriverRouteViewSelectionProvider } from "../contexts/DriverRouteViewSelectionProvider";
import { isDateStringToday } from "@src/common/lib/DateUtils";
import moment from "moment-timezone";

/**
 * Fetches and sets the driver's default start time for selected dates
 * Uses the driver's routing configuration for future dates, or current time for today
 */
export function useDriverBaseTime(
  selectedStopDate: string | undefined,
  driver: Driver | Maybe<Driver> | undefined,
  courierId: string | null
) {
  const { setSelectedBaseTime } = useDriverRouteViewSelectionProvider();
  const [getDriverDefaultRoutingConfigurations] =
    useGetDriverDefaultRoutingConfigurationsLazyQuery({
      fetchPolicy: "cache-and-network",
    });

  useEffect(() => {
    if (selectedStopDate && !isDateStringToday(selectedStopDate)) {
      if (!driver || !courierId) return;
      getDriverDefaultRoutingConfigurations({
        variables: {
          courierId: courierId,
          driverIds: [driver.id],
          dates: selectedStopDate,
        },
      }).then((res) => {
        if (res.data) {
          const driverDefaultRoutingConfigurations =
            res.data.driverDefaultRoutingConfigurations[0];
          setSelectedBaseTime(
            moment.unix(driverDefaultRoutingConfigurations.startTime)
          );
        }
      });
    } else {
      setSelectedBaseTime(moment());
    }
  }, [selectedStopDate, driver, courierId, getDriverDefaultRoutingConfigurations, setSelectedBaseTime]);
}

